import { render, staticRenderFns } from "./denied.view.vue?vue&type=template&id=cb9bed26&"
import script from "./denied.view.vue?vue&type=script&lang=ts&"
export * from "./denied.view.vue?vue&type=script&lang=ts&"
import style0 from "./denied.view.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports